import React, { useState } from "react";
import { WarningModal } from "../WarningModal";
import { useTranslation } from "react-i18next";
import { useDrawersContext } from "../../routes/tasks/drawers-context";
import { AtiraToast } from "../../utils/AtiraToast";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { taskActions } from "../../redux/task/task.slice";
import { userSliceSelectors } from "../../redux/user/user.selector";
import { taskSliceSelectors } from "../../redux/task/task.selector";
import { useFormContext } from "react-hook-form";
import { GetTasksFilterDto } from "../../model/task/dto/GetTasksFilterDto";
import fetchAfterTaskAction from "./functions/fetchAfterTaskAction";
import { useLocation } from "react-router-dom";
import { appSliceSelectors } from "../../redux/app/app.selector";
import { TestIDs } from "../../tests/types/testIds";

export const TaskDoneModal: React.FC = () => {
  const [loading, setLoading] = useState(false);

  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { getValues: contextGetValues } = useFormContext<GetTasksFilterDto>();
  const {
    task,
    setTask,
    setEntry,
    taskDoneVisible,
    setTaskDoneVisible,
    kanbanCard,
    setKanbanCard,
  } = useDrawersContext();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;
  const tasksPage = useAppSelector(taskSliceSelectors.selectTasksPage);
  const tasksPageSize = useAppSelector(taskSliceSelectors.selectTasksPageSize);
  const searchOptions = useAppSelector(appSliceSelectors.selectSearchOptions);
  const floatingTodayTasksVisible = useAppSelector(
    appSliceSelectors.floatingTodayTasksVisible,
  );

  const localOnClose = () => {
    setTaskDoneVisible(false);
  };

  const onTaskDone = async () => {
    try {
      setLoading(true);

      if (!task) {
        return;
      }

      await dispatch(
        taskActions.updateTask({
          userId,
          taskId: task._id,
          done: !task.done,
          kind: task.kind,
        }),
      ).unwrap();

      await fetchAfterTaskAction({
        userId,
        task,
        entryId: task?.parentId!,
        taskId: task?._id,
        kanbanCardId: kanbanCard?._id,
        pathname,
        tasksPage,
        tasksPageSize,
        dispatch,
        setEntry,
        setTask,
        setKanbanCard,
        contextGetValues,
        searchKeyword: searchOptions?.keyword,
        isFloatingTodayTasksOpen: floatingTodayTasksVisible === true,
      });

      setTaskDoneVisible(false);

      AtiraToast.success(
        t(!task?.done ? "tasks.done.success" : "tasks.undone.success"),
      );
    } catch (e: any) {
      AtiraToast.apiError(e);
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  if (!task) {
    return null;
  }

  return (
    <WarningModal
      isOpen={taskDoneVisible}
      onClose={localOnClose}
      title={t(
        task?.done === true
          ? "tasks.undone.modal.title"
          : "tasks.done.modal.title",
      )}
      description={t(
        task?.done === true
          ? "tasks.undone.modal.description"
          : "tasks.done.modal.description",
      )}
      onConfirm={onTaskDone}
      loading={loading}
      confirmButtonDataTestId={TestIDs.tasks.table.menu.done.modal.button}
    />
  );
};
